import React from 'react'

const Footer = () => (
  <div id="footer">
    <div className="inner">
      <ul className="icons">
        <li>
          <a href="https://www.linkedin.com/in/ajay-jangid-69b99a198/" className="icon fa-linkedin" target='blank'>
            <span className="label">Linkedin</span>
          </a>
        </li>
        <li>
          <a href="https://github.com/AjayJangid17" className="icon fa-github" target='blank'>
            <span className="label">Github</span>
          </a>
        </li>
        {/* <li>
          <a href="#" className="icon fa-dribbble">
            <span className="label">Resume</span>
          </a>
        </li> */}
        <li>
          <a href="https://ajayjangid1708@gmail.com" className="icon fa-envelope-o" target='blank'>
            <span className="label">Email</span>
          </a>
        </li>
      </ul>
      <ul className="copyright">
        <li> ajayjangid1708@gmail.com</li>
        <li>
           Click On Links!{/* <a href="http://html5up.net">HTML5 UP</a> */}
        </li>
      </ul> 

    </div>
    <br/>
      <div className="download">
      <ul className="actions">
            <li>
              <a
                href="https://github.com/AjayJangid17/Portfolio/raw/master/AJAY_Jangid_Resume.pdf"                

                download
                className="button primary icon fa-download"
                style={{backgroundColor:'white'}}
              >
                Download Resume
              </a>
            </li>
      </ul>
      </div>
  </div>
)

export default Footer
